import { Props } from "../types";

export default function ProgressBar({
  text,
  progress_1,
  progress_2,
  outerClassName,
}: Props & {
  text: string;
  progress_1: number;
  progress_2: number;
}): JSX.Element {
  return (
    <div className={`${outerClassName ? outerClassName : ""}`}>
      <div className="relative">
        <div className="flex justify-between mb-1">
          <span className="text-base font-medium text-blue-700 dark:text-white">
            {text}
          </span>
        </div>
        <div className="mb-4 flex overflow-hidden bg-gray-200 rounded-full h-4 dark:bg-gray-700">
          {progress_1 ? (
            <div
              className="flex flex-col justify-center bg-blue-600 h-4 rounded-full z-10"
              style={{ width: `${progress_1}%` }}
            >
              <span className="text-center text-xs">{progress_1}%</span>
            </div>
          ) : (
            <></>
          )}
          {progress_2 ? (
            <div
              className="flex flex-col justify-center bg-blue-400 h-4 rounded-r-full -ml-2 z-0"
              style={{ width: `${progress_2 + 3}%` }}
            >
              <span className="text-center text-xs">{progress_2}%</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
